import { useState } from 'react';
import { SERVER_URL } from '../../../config';
import service from '../../../services/userService';
import { Button, Checkbox, FormControlLabel, Stack } from '@mui/material';
import Modal from '@components/Modal';

interface PolicyModalProps {
  userId: string;
  termsConsent: boolean;
  updateAuthUser: (data: { noShowConsent: boolean; termsConsent: boolean }) => void;
  onClose?: () => void;
}

const PolicyModal = (props: PolicyModalProps) => {
  const [termsChecked, setTermsChecked] = useState(false);

  const onSubmit = async () => {
    const data = {
      noShowConsent: true,
      termsConsent: true,
    };
    try {
      await service.updateProfile(data, props.userId);
    } catch (error) {
      console.log(error);
    }
    props.updateAuthUser(data);
  };

  const policies = [
    {
      title: 'Privacy Policy',
      href: `${SERVER_URL}/conditions/privacy-policy`,
    },
    {
      title: 'Notice of Privacy Practices',
      href: `${SERVER_URL}/conditions/notice-of-privacy-practices`,
    },
    {
      title: 'Terms of Use',
      href: `${SERVER_URL}/conditions/terms-of-use`,
    },
    {
      title: 'End User License Agreement',
      href: `${SERVER_URL}/conditions/end-user-agreement`,
    },
  ]

  return (
    <Modal
      open={true}
      title="Updated Terms"
      bodyParagraphs={[
        "We have recently updated our terms and conditions, including a new no-show policy. Please read and agree to the following:",
      ]}
      children={
        <Stack direction="column" alignItems="center" spacing={0}>
          <FormControlLabel
            control={
              <Checkbox
                checked={termsChecked}
                onChange={(e) => setTermsChecked(e.target.checked)}
              />
            }
            label="I've read and agreed to the following:"
          />
          {policies.map((policy) => (
            <Button
              variant='text'
              href={policy.href}
              target="_blank"
              rel="noreferrer"
              sx={{ width: 'fit-content' }}
            >
              {policy.title}
            </Button>
          ))}
        </Stack>
      }
      buttons={[
        { 
          label: "Continue",
          onClick: onSubmit,
          variant: "contained",
          disabled: !termsChecked,
        },
      ]}
    />
  );
};

export default PolicyModal; 